export default __webpack_public_path__ + "static/media/cert-general-staff-hkgcsmeaa.0390698e.jpg";